module.exports = __webpack_public_path__ + "static/img/logo118.a4f018a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo118.png
// module id = rT/S
// module chunks = 1